import { useEffect, useState } from "react"

export function isClientSide() {
  return typeof window !== "undefined"
}

export const useIsClient = () => {
  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)
  }, [])

  return isClient
}
